import React from "react";
import PaginaPublica from "../PaginasPublicas/PaginaPublica";
import { imagenesFexcoInauguracion } from "./imagenesFexcoInauguracion";

function Revista() {
  return <PaginaPublica titulo="Fexco Inauguracion" imagenes={imagenesFexcoInauguracion} />;
}

export default Revista;